import * as d3 from "d3";

function findSquare(coordinates, length) {
  const n = coordinates.length;
  let [x, y] = d3.polygonCentroid(coordinates);
  const square = [
    [x + 2 * length, y],
    [x + 2 * length, y + 2 * length],
    [x, y + 2 * length],
    [x, y]
  ];
  let res = [];
  for (let i in square) {
    res.push(square[+i % 4]);
    const interpolator = d3.interpolateNumberArray(
      square[+i % 4],
      square[(+i + 1) % 4]
    );
    for (let t of d3.range(0, 1, 4 / n)) {
      res.push(interpolator(t));
    }
    res.push(square[(+i + 1) % 4]);
  }

  return res;
}

const square = _projection => {
  let projection = _projection;

  function path(d) {
    let coords = biggestPart(d.geometry.coordinates);
    let coordinates = coords.map(coord => {
      return projection(coord);
    });
    const length = projection.scale() / 20;
    const squareCo = findSquare(coordinates, length);
    return "M" + squareCo.join("L") + "Z";
  }

  path.projection = function(_projection) {
    if (!arguments.length) return projection;
    projection = _projection;
    return path;
  };

  path.center = function(feature) {
    let coords = biggestPart(feature.geometry.coordinates).map(coord => {
      return projection(coord);
    });
    return d3.polygonCentroid(coords);
  };

  return path;
};

function biggestPart(coordinates) {
  let coords = coordinates[0];
  if (coords.length == 1) {
    //find the biggest part in each province
    var max_length = -1;
    var max_i = -1;
    for (var i = 0; i < coordinates.length; i++) {
      if (max_length < coordinates[i][0].length) {
        max_length = coordinates[i][0].length;
        max_i = i;
      }
    }
    coords = coordinates[max_i][0];
  }
  return coords;
}

export default square;

export { biggestPart };
